import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IPageComponent } from '~Interfaces/ipagecomponent';
import { ContactService } from '~Services/contact.service';

import { FormulaireModel } from '../../models/formulaire-model';
import { T } from '../../tools/Traductions';

/**
 * Composant de contact
 * @extends IPageComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent extends IPageComponent implements OnInit {
  motifs: any[] = [];
  sousMotifs: any[] = [];
  fournisseurs: any[] = [];

  nom: string = '';
  email: string = '';

  piecesjointes: FileList;
  extensions: string[] = ['png', 'jpeg', 'jpg', 'gif', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xlsx', 'xls'];

  succes: boolean = false;

  tailleFichiers: number = 0;

  model: FormulaireModel = new FormulaireModel;

  /**
   * Constructeur
   * @param contactService
   */
    constructor(@Inject(ContactService) private contactService: ContactService, private route: ActivatedRoute, private hostRef: ElementRef) { super() }
    @ViewChild('fichiers', null) fichiers: NgModel;
  /**
   * Initialisation du composant
   */
  ngOnInit() {
    // Récupération des motifs de contact
    this.contactService.obtenirDonnees().subscribe((retour: any) => {
      if (retour && retour.Result) {
        this.nom = retour.Result.Demandeur.NomPrenom;
        this.email = retour.Result.Demandeur.Email;
        this.fournisseurs = retour.Result.Fournisseurs;
        this.motifs = retour.Result.Motifs;
        this.sousMotifs = retour.Result.SousMotifs;
      }
    });
      this.model.PiecesJointes = [];
    }

    @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
        const file = event && event.item(0);
        if (file) {
            this.convertirPiecesJointes(file);
        }
    }

/**
* Suppression d'une pièce jointe
*/
    supprimerPieceJointe(id) {
        var fileInput = (<HTMLInputElement>document.getElementById(id));
        if ((<HTMLInputElement>document.getElementById(id)).files.item(0) != null) {
            for (let i = 0; i < this.model.PiecesJointes.length; i++) {
                if (this.model.PiecesJointes[i].Nom == (<HTMLInputElement>document.getElementById(id)).files.item(0).name) {
                    this.model.PiecesJointes.splice(i, 1);
                }
            }
        }
        if (id == "pieceJointe1") {
            fileInput.value = null;
        }
        // Si on ne se trouve pas sur la première pièce jointe on supprime la div entière afin d'éviter les champs vides
        else {
            var divParent = fileInput.parentElement.parentElement;
            divParent.remove();
        }
        this.verifierPiecesJointes();
    }

/**
* Récupération des attributs de style
*/
    getContentAttr(): string {
        const attrs = this.hostRef.nativeElement.attributes
        for (let i = 0, l = attrs.length; i < l; i++) {
            if (attrs[i].name.startsWith('_nghost-')) {
                return `_ngcontent-${attrs[i].name.substring(8)}`
            }
        }
    }

/**
* Ajout d'une pièce jointe
*/
    ajouterPieceJointe(id) {
        var input = (<HTMLInputElement>document.getElementById("pieceJointe" + id));
        //On vérifie que la pièce jointe précédente a bien été ajoutée afin de ne pas créer un champ vide
        if (input.value != null) {
            var id = id + 1

            var div = document.createElement("div");
            var divGroup = document.createElement("div");
            var input = document.createElement("input");
            var button = document.createElement("button");
            var label = document.createElement("label");

            div.className = "pj";

            divGroup.className = "groupe-pj";
            divGroup.setAttribute(this.getContentAttr(), '')

            input.className = "custom-file-input";
            input.name = "piecesJointes";
            input.id = "pieceJointe" + id;
            input.type = "file";
            input.onchange = () => this.ajouterPieceJointe(id);
            input.setAttribute("ngModel", "piecesjointes");
            input.setAttribute(this.getContentAttr(), '')

            button.className = "icon-trash";
            button.type = "button";
            button.onclick = () => this.supprimerPieceJointe("pieceJointe" + id)
            button.setAttribute(this.getContentAttr(), '')

            label.className = "label-select-file"
            label.innerHTML = T('contact.piece-jointe.libelle');

            divGroup.appendChild(input);
            divGroup.appendChild(button);
            div.appendChild(label);
            div.appendChild(divGroup);

            var nextDiv = document.getElementById("piecesjointeserreur");
            var form = document.getElementById("form");
            form.insertBefore(div, nextDiv);
        }
    }

  /**
  * Convertir les pieces jointes
  */

    convertirPiecesJointes(file: File) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.model.PiecesJointes.push({ Nom: file.name, Stream: reader.result })
            this.verifierPiecesJointes();
        };
        this.tailleFichiers += file.size / 1024 / 1024;
    }

    verifierPiecesJointes() {
        var regexItem = new RegExp("^([a-zA-Z0-9 ]{1,100})(.[a-z]*)$");
        if (this.model.PiecesJointes.length == 0) {
            setTimeout(() => this.fichiers.control.setErrors(null));
        }
        else {
            for (let i = 0; i < this.model.PiecesJointes.length; i++) {
                if (!this.model.PiecesJointes[i].Nom.match(regexItem)) {
                    setTimeout(() => this.fichiers.control.setErrors({ 'libelle': true }));
                }
                else if (!this.extensions.includes(this.model.PiecesJointes[i].Nom.split('.').pop())) {
                    setTimeout(() => this.fichiers.control.setErrors({ 'format': true }));
                }
                else if (this.tailleFichiers > 5) {
                    setTimeout(() => this.fichiers.control.setErrors({ 'taille': true }));
                }
                else {
                    setTimeout(() => this.fichiers.control.setErrors(null));
                }
            }
        }
    }
  
  /**
   * Envoyer la demande de contact
   */
    envoyerDemande() {
        this.contactService
            .envoyerDemande(this.model)
            .subscribe((retour: any) => {
            if (retour && retour.Result) {
                this.succes = true;
            }
        });
    }
}
